<template>
  <Teleport to="body">
    <Modal v-model="show" @accept="emit('accept')">
      <ModalContent size="medium">
        <template #header>
          <Heading level="h2">{{ title }}</Heading>
        </template>

        <div class="tw-space-y-2">
          <Text v-for="(line, index) in lines" :key="index">{{ line }}</Text>
          <Text v-if="warning" class="tw-font-black tw-text-orange">{{ warning }}</Text>
        </div>

        <template #footer="{ accept, reject }">
          <Button color="transparent" outlined @click="reject">{{ t('networking.confirm_cancel') }}</Button>
          <Button color="semiTransparentWhite" outlined @click="accept">
            {{ acceptLabel }}
          </Button>
        </template>
      </ModalContent>
    </Modal>
  </Teleport>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

import { Button, Heading, Modal, ModalContent, Text } from '@slideslive/fuse-kit/vue';

defineProps({
  title: { type: String, default: '' },
  lines: { type: Array, default: () => [] },
  warning: { type: String, default: '' },
  acceptLabel: { type: String, default: '' },
});

const show = defineModel();

const emit = defineEmits(['accept']);

const { t } = useI18n();
</script>
